import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from './pipes/date.format.pipe';
import { WalletPassesComponent } from '../core/components/wallet-passes/wallet-passes.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { AddToCalendarsComponent } from '../core/components/add-to-calendars/add-to-calendars.component';
import { ThreedSeatsPickerComponent } from '../core/components/threed-seats-picker/threed-seats-picker.component';
import { PayWithWalletComponent } from '../core/components/pay-with-wallet/pay-with-wallet.component';
import { PopUpAdComponent } from '../core/components/pop-up-ad/pop-up-ad.component';
import { TwoDMapSeatsPickerComponent } from '../core/components/2dmap-seats-picker/2dmap-seats-picker.component';
import { CustomCheckoutDatePipe } from './pipes/CustomCheckoutDate.format.pipe';

@NgModule({
  declarations: [
    DateFormatPipe,
    CustomCheckoutDatePipe,
    WalletPassesComponent,
    PopUpAdComponent,
    AddToCalendarsComponent,
    PayWithWalletComponent,
  ],
  exports: [
    DateFormatPipe,
    CustomCheckoutDatePipe,
    WalletPassesComponent,
    PopUpAdComponent,
    GooglePayButtonModule,
    AddToCalendarsComponent,
    PayWithWalletComponent,
    ThreedSeatsPickerComponent,
    TwoDMapSeatsPickerComponent,
  ],
  imports: [
    CommonModule,
    GooglePayButtonModule,
    ThreedSeatsPickerComponent,
    TwoDMapSeatsPickerComponent,
  ],
})
export class ShareModule {}
